import "./calender.css";


export default function AppCalender ({}) {

    return (
        <div className="calendar-continer">
            <div>
                <p> לוח שנה </p>
            </div>

            <div>

            </div>
        </div>
    )
}